import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_APP_TITLE: z.string().min(1),
  VITE_ENABLE_MOCK_API: z.string().transform((v) => v === 'true'),
  VITE_MSAL_CLIENT_ID: z.string().uuid(),
  VITE_MSAL_TENANT_ID: z.string().uuid(),
  VITE_API_SCOPE: z.string().min(1).optional(),
  VITE_AZURE_AD_AUTHORITY: z.string().url(),
  VITE_AZURE_AD_CLIENT_ID: z.string().uuid(),
});

type RuntimeConfig = Partial<Record<keyof z.input<typeof envSchema>, string>>;

function isUnresolvedToken(value: string): boolean {
  return /^__[^\s]+__$/.test(value);
}

function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined' || !window.__Mable_CONFIG__) {
    return {};
  }

  const filteredEntries = Object.entries(window.__Mable_CONFIG__).filter(([, value]) => {
    if (typeof value !== 'string') {
      return false;
    }

    return !isUnresolvedToken(value);
  });

  return Object.fromEntries(filteredEntries) as RuntimeConfig;
}

export const env = envSchema.parse({
  ...import.meta.env,
  ...getRuntimeConfig(),
});
